
export enum SchedulerExitState { nothingMoreToDo, giveMeAdditionalTime }
